import { render, staticRenderFns } from "./checkOrderLabels.vue?vue&type=template&id=01b6fbf7&scoped=true&"
import script from "./checkOrderLabels.vue?vue&type=script&lang=js&"
export * from "./checkOrderLabels.vue?vue&type=script&lang=js&"
import style0 from "./checkOrderLabels.vue?vue&type=style&index=0&id=01b6fbf7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b6fbf7",
  null
  
)

component.options.__file = "checkOrderLabels.vue"
export default component.exports